module.exports = __webpack_public_path__ + "img/tm.eba7605d.png";